import type { Backlink } from '@api/types/backlinks';
import { getDocumentBacklinksCount } from '@utils/documentBacklinks';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { RelatedLinksIndicator } from '@shared/ui';
import { buildDocumentRelatedLinkItems } from './buildDocumentRelatedLinkItems';

export type DocumentRelatedLinksProps = {
  backlinks?: Backlink[];
  showEmptyState?: boolean;
};

function DocumentRelatedLinksComponent(props: DocumentRelatedLinksProps) {
  const { id: auditId } = useParams<{ id: string }>();
  const { t } = useTranslation('dashboard', { keyPrefix: 'documents' });
  const { t: tGlobal } = useTranslation('dashboard', { keyPrefix: 'global' });

  const items = useMemo(
    () =>
      buildDocumentRelatedLinkItems(auditId, props.backlinks, {
        request: tGlobal('request'),
        task: tGlobal('task'),
        meeting: tGlobal('meeting'),
        document: tGlobal('documents'),
        view: tGlobal('view'),
        tickmark: tGlobal('tickmark'),
        finding: tGlobal('finding'),
        findingUnavailable: tGlobal('finding_link_unavailable'),
      }),
    [auditId, props.backlinks, tGlobal],
  );

  const count = useMemo(() => getDocumentBacklinksCount(props), [props]);

  return (
    <RelatedLinksIndicator
      items={items}
      count={count}
      emptyLabel={props.showEmptyState ? t('no_backlinks') : undefined}
      menuTitle={t('backlinks')}
      linksLabel={t('backlinks', { count })}
    />
  );
}

export const DocumentRelatedLinks = memo(DocumentRelatedLinksComponent);
